import { Button } from '@/components/ui/button'
import { unpin } from '@/atoms/pin'
import { HugeiconsIcon } from '@hugeicons/react'
import { Loading03Icon, PinIcon } from '@hugeicons/core-free-icons'
import { NostrEvent } from '@nostr/tools/wasm'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useCurrentPubkey } from '@/atoms/session'

export default function PinnedButton({ event }: { event: NostrEvent }) {
  const { t } = useTranslation()
  const pubkey = useCurrentPubkey()
  const [hovered, setHovered] = useState(false)
  const [unpinning, setUnpinning] = useState(false)

  if (event.pubkey !== pubkey) {
    return (
      <div className="flex gap-1 text-sm items-center text-primary mb-1 px-4 py-0 h-fit">
        <HugeiconsIcon icon={PinIcon} size={16} className="shrink-0" />
        {t('Pinned')}
      </div>
    )
  }

  return (
    <Button
      className="flex gap-1 text-sm text-primary items-center mb-1 px-4 py-0.5 h-fit"
      variant="link"
      onClick={(e) => {
        e.stopPropagation()
        setUnpinning(true)
        unpin(event).finally(() => setUnpinning(false))
      }}
      disabled={unpinning}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {unpinning ? (
        <HugeiconsIcon icon={Loading03Icon} size={16} className="animate-spin shrink-0" />
      ) : (
        <HugeiconsIcon icon={PinIcon} size={16} className="shrink-0" />
      )}
      {unpinning ? t('Unpinning') : hovered ? t('Unpin') : t('Pinned')}
    </Button>
  )
}
